module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "switchRole"
    }
  }, [_c('ul', {
    staticClass: "unitArea"
  }, [(_vm.myInclude(_vm.roleIds, 'SupervisionUnit')) ? _c('li', {
    staticClass: "box",
    style: (_vm.getStyle)
  }, [_c('a', {
    staticClass: "unitName",
    class: {
      active: _vm.roleId == 'SupervisionUnit'
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.getUnitType('SupervisionUnit')
      }
    }
  }, [_vm._v("监理单位")])]) : _vm._e(), _vm._v(" "), (_vm.myInclude(_vm.roleIds, 'BuildUnit')) ? _c('li', {
    staticClass: "box",
    style: (_vm.getStyle)
  }, [_c('a', {
    staticClass: "unitName",
    class: {
      active: _vm.roleId == 'BuildUnit'
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.getUnitType('BuildUnit')
      }
    }
  }, [_vm._v("施工单位")])]) : _vm._e(), _vm._v(" "), (_vm.myInclude(_vm.roleIds, 'unit')) ? _c('li', {
    staticClass: "box",
    style: (_vm.getStyle)
  }, [_c('a', {
    staticClass: "unitName",
    class: {
      active: _vm.roleId == 'unit'
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.getUnitType('unit')
      }
    }
  }, [_vm._v("建设单位")])]) : _vm._e(), _vm._v(" "), (_vm.myInclude(_vm.roleIds, 'SE')) ? _c('li', {
    staticClass: "box",
    style: (_vm.getStyle)
  }, [_c('a', {
    staticClass: "unitName",
    class: {
      active: _vm.roleId == 'SE'
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.getUnitType('SE')
      }
    }
  }, [_vm._v("总监理工程师")])]) : _vm._e(), _vm._v(" "), (_vm.myInclude(_vm.roleIds, 'pm')) ? _c('li', {
    staticClass: "box",
    style: (_vm.getStyle)
  }, [_c('a', {
    staticClass: "unitName",
    class: {
      active: _vm.roleId == 'pm'
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.getUnitType('pm')
      }
    }
  }, [_vm._v("项目经理")])]) : _vm._e(), _vm._v(" "), (_vm.myInclude(_vm.roleIds, 'UnitPerson')) ? _c('li', {
    staticClass: "box",
    style: (_vm.getStyle)
  }, [_c('a', {
    staticClass: "unitName",
    class: {
      active: _vm.roleId == 'UnitPerson'
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.getUnitType('UnitPerson')
      }
    }
  }, [_vm._v("建设单位负责人")])]) : _vm._e()]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "unitSelect",
    attrs: {
      "placeholder": "请选择企业"
    },
    model: {
      value: (_vm.unitId),
      callback: function($$v) {
        _vm.unitId = $$v
      },
      expression: "unitId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.unitId,
      attrs: {
        "label": item.unitName,
        "value": item.unitId
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "unit-btn-group"
  }, [_c('center', [_c('el-button', {
    attrs: {
      "disabled": _vm.unitId == null
    },
    on: {
      "click": _vm.enterSys
    }
  }, [_vm._v("切换身份，进入系统")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出系统")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8b0b55","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/switchRole.vue
// module id = 593
// module chunks = 143